type Props = {
  collapsed?: boolean;
};

export default function RecruitmentIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.4)" }}
        className={collapsed ? "" : "relative left-[8px]"}
      >
        <path
          d="M16.5001 7.81285C14.2207 9.13164 11.6329 9.82409 8.99949 9.81995C6.36647 9.82409 3.77919 9.13188 1.5 7.81351M8.06199 7.31995H9.93699M12.1245 3.56995V2.31995C12.1245 1.98843 11.9928 1.67048 11.7584 1.43606C11.524 1.20164 11.206 1.06995 10.8745 1.06995H7.12449C6.79297 1.06995 6.47503 1.20164 6.2406 1.43606C6.00618 1.67048 5.87449 1.98843 5.87449 2.31995V3.56995M2.1251 3.56995H15.8751C16.2203 3.56995 16.5001 3.84977 16.5001 4.19495V14.195C16.5001 14.5401 16.2203 14.82 15.8751 14.82H2.1251C1.77992 14.82 1.5001 14.5401 1.5001 14.195V4.19495C1.5001 3.84977 1.77992 3.56995 2.1251 3.56995Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
